<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
        <v-alert
            :value="alerteditar"
            color="green"
            dark
            dismissible
            border="top"
            transition="scale-transition"
        >
          Se edito su perfil con éxito.
        </v-alert>
        <v-row justify="center">
<v-col cols="12" lg="8" md="8" sm="12">

        <v-card color="#393E46">
    <v-card-title>Datos Personales</v-card-title>
<v-card-text>

  <v-form>
    <v-row>
      <v-col cols="12" sm="4" lg="4" md="4">
    <v-text-field v-model="usuario.nombre" label="Nombre" placeholder="Nombre"></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" lg="4" md="4">
        <v-text-field v-model="usuario.apellidoPaterno" label="Apellido Paterno" placeholder="Apellido Paterno"></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" lg="4" md="4">
        <v-text-field v-model="usuario.apellidoMaterno"  label="Apellido Materno" placeholder="Apellido Materno"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="6" md="6">
        <v-text-field prepend-icon="fas fa-at" type="email" label="Email" disabled v-model="usuario.email" placeholder="Email"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="6" md="6">
        <v-text-field prepend-icon="fas fa-phone" label="Telefono" v-model="usuario.telefono" placeholder="Telefono"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <span class="block text-gray-600 text-sm text-left font-bold mb-2"
        >Selecciona Fecha de Nacimiento</span
        >
        <vc-date-picker  class="inline-block h-full" locale="es-PE"    is-dark mode="date"  :first-day-of-week="2" timezone="America/New_York" v-model="usuario.fechaNacimiento" >
          <template v-slot="{ inputValue, togglePopover }">
            <div class="flex items-center">
              <v-btn

                  @click="togglePopover()"
              >
                <v-icon>fas fa-calendar</v-icon>
              </v-btn>
              <input
                  :value="inputValue"
                  class="bg-white  text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                  style="color: white; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: white;"
                  readonly
              />
            </div>
          </template>
        </vc-date-picker>

      </v-col>
      <v-col cols="12" sm="6" lg="6" md="6">
        <v-autocomplete
            v-model="usuario.paisNac"
            :items="paises"
            return-object
            label="Pais de Nacimiento"
            placeholder="Pais de Nacimiento"
            prepend-icon="fas fa-flag"
            item-text="pais"
            @change="dameTiposDocumentos"
        >
          <template v-slot:selection="data">
            <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"

            >
              <v-avatar left>
                <v-img :src="require(`@/assets/flags/gc_country_flag_${data.item.codigo}.svg`)"></v-img>
              </v-avatar>
              {{ data.item.pais }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-avatar>
                <img :src="require(`@/assets/flags/gc_country_flag_${data.item.codigo}.svg`)">
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="data.item.pais"></v-list-item-title>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>

      </v-col>
      <v-col cols="12" sm="6" lg="6" md="6">
        <v-autocomplete prepend-icon="fas fa-id-card" return-object item-text="tipoDocumento" v-model="usuario.tipoDocumento" :items="tiposdocumento" placeholder="Tipo de Documento" label="Tipo de Documento">

        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" lg="6" md="6">
        <v-text-field prepend-icon="fas fa-id-card-alt" label="Numero de Documento" v-model="usuario.dni" placeholder="Numero de Documento"></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</v-card-text>
          <v-card-actions>
           <v-row> <v-col><v-btn color="primary" @click="cambiaUsuario">
              Guardar
            </v-btn></v-col>
           <v-col>
             <v-btn color="red">
                <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'password'}">Cambiar Password</router-link>
             </v-btn>
           </v-col>
             <v-col>
               <v-btn color="blue">
                 <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'fotoperfil'}">Foto</router-link>
               </v-btn>
             </v-col>
             <v-col>
               <v-btn color="green">
                 <router-link color="white" style="text-decoration: none; color: white" :to="{ name: 'direccion'}">Direccion</router-link>
               </v-btn>
             </v-col>
           </v-row>
          </v-card-actions>
        </v-card>




</v-col>


        </v-row>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>
import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import axios from 'axios';
import moment from "moment-timezone";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'perfil',
  title: 'Perfil | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
  },
  data: () => ({
    paises: {},
    overlay:false,
    date: new Date().toISOString().substr(0, 10),
    provincias:[],
    token:'',
    alerteditar: false,
    ciudades:[],
    distritos:[],
    tiposdocumento: [],
    password:'',
    cpassword: '',
    getips:'',
    menu1:false,
  }),
  mounted() {
    this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
   this.usuario.fechaNacimiento = new Date(this.usuario.fechaNacimiento+'T12:00:00.000Z')
    this.getPaises()
  },
  methods:{
    getPaises(){
      axios.get("paises/activos",{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.paises = response.data

            this.dameTiposDocumentos()
          })
    },

    formatDatee(value) {
      return moment(value).locale('es-pe').format("DD MMMM YYYY")
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    dameTiposDocumentos(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'tiposdocumento/pais/' + this.usuario.paisNac.id ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.tiposdocumento = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false
          })
          .catch((error)  => {
            console.log(error);
          });
    },

    formatDarete (date) {
      var fec = moment(date).locale('es-pe');
      return fec.tz("America/Lima").format("DD-MM-YYYY");
    },
    cambiaUsuario(){
      var bodyFormData = new FormData();
      this.usuario.createdAt = this.formatDateee(new Date(this.usuario.createdAt))
      this.usuario.fechaNacimiento = this.formatDate(this.usuario.fechaNacimiento)
      bodyFormData.append('data',JSON.stringify(this.usuario));
      axios.post("personas/save",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            console.log(response.data)
            this.usuario.fechaNacimiento = new Date(this.usuario.fechaNacimiento)
            store.dispatch("fetchUsuario", this.usuario);
            this.overlay = false;
            this.dialog=false;
            this.alerteditar = true;
          //  this.abreviado =response.data.persona.nombre.charAt(0) + response.data.persona.apellidoPaterno.charAt(0)
            this.desconectado = false;
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.overlay = false;
            console.log(error);
          });
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>
